import { Button, Heading } from '@big-red-group/storefront-common-ui'
import { Buttons, List, Wrapper } from './NeedHelp.styles'
import { useRouter } from 'next/router'

const NeedHelp: React.FC<{
  helpCode: string
  supplierName: string
  showButtons?: boolean
  callCentreNumber?: string
  dataTestId?: string
}> = ({ helpCode, supplierName, showButtons = true, callCentreNumber, dataTestId }) => {
  const router = useRouter()
  const { lang } = router.query
  return (
    <>
      <Wrapper>
        <Heading size="L" dataTestId={dataTestId}>Need help?</Heading>
        <List>
          {callCentreNumber ? (
            <li>
              Contact us at <a href={`tel:${callCentreNumber.replaceAll(' ', '')}`}>{callCentreNumber}</a>
            </li>
          ) : (
            <>
              <li>
                Email us at <a href="mailto:enquiry@experienceoz.com.au">enquiry@experienceoz.com.au</a>
              </li>
              <li>Help code: {helpCode}</li>
              <li>This experience is supplied by {supplierName}</li>
            </>
          )}
        </List>
        {showButtons && (
          <Buttons>
            <Button size="M" onClick={() => router.push(`/${lang}/faqs`)}>
              Contact us
            </Button>
          </Buttons>
        )}
      </Wrapper>
    </>
  )
}

export default NeedHelp
